import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSelector,useDispatch } from 'react-redux';
import { fetchJobs } from '../redux/actions/jobsActions';
import { fetchApplications } from '../redux/actions/applicationsActions';
import Spinner from 'react-bootstrap/Spinner';
import supabase from '../supabase';

function Dashboard() {
    const sidebarState = useSelector(state => state.sidebarReducres);
    const jobs = useSelector(state=> state.jobsReducer.jobs)
    const applications = useSelector(state=> state.applicationsReducer.applications)
    const [loading,setLoading] = useState(true)
    const dispatch = useDispatch()

    useEffect(()=>{
        onFetchJobs()
    },[])
    
    const onFetchJobs = async() =>{
        setLoading(true)
        const res = await dispatch(fetchJobs())
        const res2 = await dispatch(fetchApplications())
        if(res.success && res2.success){
            setLoading(false)
        }else if(!res.success || !res2.success){
            setLoading(false)
        }
    }

    const totalJobsCount = jobs.filter((item)=>{return item.status===true})
    const totalApplicationsCount = applications.filter((item)=>{return item.status===true})
    return (
        <>
        <Sidebar/>
        <Header/>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h5 className='mb-3'>Dashboard</h5>
                        </Col>
                    </Row>
                    {loading?<div className='spinner'><Spinner animation="grow"/></div>
                    :<>
                    <Row>
                        <Col xs="6" sm="6" md="3" lg="3" xl="3" xxl="3" className='d-flex'>
                            <div className="dash-count">
                                <div className="dash-counts">
                                    <h4>{totalJobsCount.length}</h4>
                                    <h5>Total Jobs</h5>
                                </div>
                                <div className="dash-imgs">
                                    <i className="fa fa-rocket"></i>
                                </div>
                            </div>
                        </Col>

                        <Col xs="6" sm="6" md="3" lg="3" xl="3" xxl="3" className='d-flex'>
                            <div className="dash-count das1">
                                <div className="dash-counts">
                                    <h4>{totalApplicationsCount.length}</h4>
                                    <h5>Total Applied</h5>
                                </div>
                                <div className="dash-imgs">
                                    <i className="fa fa-user-group"></i>
                                </div>
                            </div>
                        </Col>

                        <Col xs="6" sm="6" md="3" lg="3" xl="3" xxl="3" className='d-flex'>
                            <div className="dash-count das2">
                                <div className="dash-counts">
                                    <h4>1</h4>
                                    <h5>Total Location</h5>
                                </div>
                                <div className="dash-imgs">
                                    <i className="fa fa-location"></i>  
                                </div>
                            </div>
                        </Col>

                        <Col xs="6" sm="6" md="3" lg="3" xl="3" xxl="3" className='d-flex'>
                            <div className="dash-count das3">
                                <div className="dash-counts">
                                    <h4>{totalJobsCount.length}</h4>
                                    <h5>Total Positions</h5>
                                </div>
                                <div className="dash-imgs">
                                    <i className="fa fa-book"></i>  
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {/* Recent Jobs */}
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h5 className='mb-0'>Recent Active Jobs</h5>
                        </Col>
                        {jobs?.map((item,index)=>{
                        return <>{item.status&&<Col key={index} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                            <div className='job_box das3'>
                                <h4 className="text-dark c_name mb-0">{item.position}</h4>
                                <div className="dash-count bill_box das3">
                                    <div className="dash-counts">
                                        <h5 className="text-dark text-green">Location :<span>{item.location}</span></h5>
                                        <h5 className="text-dark">Post Date : {new Date(item.created_at).getDate() + '-' +  (new Date(item.created_at).getMonth()+1) + '-' + new Date(item.created_at).getFullYear()}</h5>
                                    </div>
                                    <div className="dash-imgs">
                                    <h5 className="text-dark">Job Type : <span>{item.type}</span></h5>
                                        <h5 className="text-dark">Required Experience : <span>{item.experience}</span></h5>
                                    </div>
                                </div>
                                <h4 className="text-dark c_name mb-0">Job Description:</h4>
                                <p className='mt-2' dangerouslySetInnerHTML={{__html: item.description}}></p>
                            </div>
                        </Col>}</>
                        })}
                        {/* Recent Jobs */}
                    </Row>
                    </>}
            </Container>
            </div>
        </div>
        </>
    );
}

export default Dashboard;
